export const journalFilterMixin = {
  data() {
    return {
      label: {
        glAcctNoBranch: 'GL Account No. Branch',
        glAcctNo: 'GL Account No.',
        glAcctNoFund: 'GL Account No. Fund',
        glAcctNoSuffix: 'GL Account No. Suffix',
        jrnlNo: 'Journal No.',
        curr: 'Currency',
        status: 'Status',
        date: 'Date',
        adjAmount: 'Adjustment Amount',
        reason: 'Reason'
      },
      filter: {
        glAcctNoBranch: '',
        glAcctNo: '',
        glAcctNoFund: '',
        glAcctNoSuffix: '',
        jrnlNo: '',
        curr: '',
        status: '',
        date: '',
        adjAmount: '',
        reason: ''
      },
      statusList: [
        { label: 'In-Progress', value: 'IP' },
        { label: 'Rejected', value: 'RJ' },
        { label: 'Approved', value: 'AP' },
        { label: 'Waiting for Approval', value: 'WA' }
      ]
    }
  },
  methods: {
    doClearFilters() {
      var thisPage = this
      Object.keys(this.filter).forEach(function(key, index) {
        thisPage.filter[key] = ''
      })
      this.performSearch()
    },
    doFilters() {
      this.performSearch()
    }
  }
}
